import ButtonLink from "components/common/Link";
import { isEmpty } from "lodash";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { tokens } from "styles/Tokens";
import { getUIFormatDate } from "utils/DateHelper";
import { getPlanDetailsRoute } from "utils/StoreUtils";
import Typography from "../../common/Typography";

interface Props {
  data: any;
  navigate?: any;
}

function PlanBadge(props: Props) {
  const { data } = props;

  const location = useLocation();

  const isPlanDetailsPage = location?.pathname?.split("/")[1] === "plandetails";

  const showBadge = data.isPlanNotImplemented
    ? "Plan Added to Property"
    : data.myPlans && !isPlanDetailsPage
    ? "Plan Added to My Plans"
    : "";

  if (!isEmpty(showBadge))
    return (
      <Typography
        component={"span"}
        variant={"label"}
        changeVariant={false}
        sx={{
          marginBottom: "4px",
          "&::before": {
            content: '""',
            display: "inline-block",
            height: "8px",
            width: "8px",
            borderRadius: "100%",
            backgroundColor: tokens.Primary.Primary400,
            marginRight: "4px"
          }
        }}
      >
        {showBadge}
      </Typography>
    );

  if (data?.myPlans && !data.isPlanNotImplemented && isPlanDetailsPage) {
    const addedToMyPlansDate = getUIFormatDate(data?.myPlans?.[0].createdDate);

    return (
      <div className="last-added-text">
        <>
          <Typography children={"Last Added:"}></Typography>
          <ButtonLink
            text={addedToMyPlansDate}
            textVariant={"body2"}
            onClick={() => props.navigate(`/${getPlanDetailsRoute()}/${data?.myPlans[0].id}`)}
          ></ButtonLink>
        </>
      </div>
    );
  }

  if (data?.dueDate) {
    let date = new Date();
    let yesterday = date.setDate(date.getDate() - 1);
    const isOverdue = moment(data?.dueDate).isBefore(moment(yesterday));
    return (
      <>
        <Typography
          variant={"label"}
          changeVariant={false}
          color={isOverdue ? tokens.Text.Feedback.OverdueLight : tokens.Text.General.Tertiary}
          showBold
          sx={{
            marginBottom: "4px",
            "&::before": {
              content: '""',
              display: "inline-block",
              height: "8px",
              width: "8px",
              borderRadius: "100%",
              backgroundColor: isOverdue ? tokens.Text.Feedback.OverdueLight : tokens.Text.General.Tertiary,
              marginRight: "4px"
            }
          }}
        >
          {isOverdue ? "Overdue" : "Duedate"}
          <Typography variant="label" changeVariant={false}>
            {isOverdue ? " since" : ""}
            {` ${getUIFormatDate(data?.dueDate)}`}
          </Typography>
        </Typography>
      </>
    );
  }
  return null;
}
export default PlanBadge;
